module.exports = __webpack_public_path__ + "static/media/article_registration_32_blue.ea5b194b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/article_registration_32_blue.svg
// module id = 1105
// module chunks = 0